module.exports = __webpack_public_path__ + "71cdbba18970ee73cf51c455b97e520a.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/audi.png
// module id = 623
// module chunks = 0